import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./FunFact1.css";
import DYK from "./Assets/dyk.png";
import Avatar from "./Assets/avatar2.png"; 

// FunFact1 component receives the onNext function as a prop, which is triggered when the user clicks "Next"
const FunFact1 = ({ onNext }) => {
  // State to manage the timer countdown (initially set to 5 seconds)
  const [timer, setTimer] = useState(5);
  // State to control the visibility of the timer after it reaches 0
  const [hideTimer, setHideTimer] = useState(false);

  // useEffect hook to start the countdown and manage the timer's behavior
  useEffect(() => {
    if (timer > 0) {
      // Set an interval to decrease the timer every second
      const countdown = setInterval(
        () => setTimer((prevTime) => prevTime - 1),
        1000
      );
      return () => clearInterval(countdown); // Clear the interval when component unmounts or timer changes
    } else {
      // After the timer reaches 0, wait 1 second before hiding the timer
      const hideTimeout = setTimeout(() => setHideTimer(true), 1000);
      return () => clearTimeout(hideTimeout); // Clear the timeout if the component unmounts
    }
  }, [timer]); // Depend on the 'timer' state to trigger the effect when it changes

  return (
    <div className="funfact-container">
      {/* Avatar image with animation using framer-motion */}
      <motion.img
        className="avatar-img"
        src={Avatar}
        alt="Avatar"
        initial={{ opacity: 0, y: "50%" }} // Initial state: hidden and translated
        animate={{ opacity: 1, y: 0 }} // Animated to full opacity and reset position
        transition={{ duration: 1, ease: "easeOut" }} // Transition duration and easing
      />

      {/* Content container with animated entrance */}
      <motion.div
        className="cont"
        initial={{ opacity: 0, y: "-50%" }} // Initially hidden above the screen
        animate={{ opacity: 1, y: 0 }} // Animated to full visibility and reset position
        transition={{ duration: 1, ease: "easeOut" }} // Transition properties
      >
        {/* "Did You Know" image */}
        <img className="dyk-img" src={DYK} alt="DYK" />

        {/* Circular timer with dynamic styles */}
        <div
          className={`timer1-container ${hideTimer ? "hidden" : ""}`} // Hide timer when time is up
          style={{
            "--timer-percentage": (timer / 5) * 100, // Dynamic styling for the circular progress
          }}
        >
          <div className="circular-timer1">{timer}</div>{" "}
          {/* Display the timer */}
        </div>

        {/* Fun fact paragraph */}
        <p className="fun-p">
          Research shows that 80% of PhD students report working 8 hours a day
          or more, but only 30% of them feel confident that their work will be
          of publishable quality.
        </p>
      </motion.div>

      {/* "Next" button with animation */}
      <motion.div
        className="btn-div"
        initial={{ opacity: 0, y: "-50%" }} // Initially hidden above the screen
        animate={{ opacity: 1, y: 0 }} // Animated to full visibility and reset position
        transition={{ duration: 1, ease: "easeOut", delay: 0.2 }} // Transition properties with delay
      >
        {/* Next button, visible when the timer finishes */}
        <button
          className={`next-button ${hideTimer ? "visible" : ""}`} // Apply "visible" class when timer is done
          onClick={onNext} // Trigger the onNext function when clicked
          disabled={timer > 0} // Disable the button if the timer is not finished
        >
          Next
        </button>
      </motion.div>
    </div>
  );
};

export default FunFact1;
